module.exports = __webpack_public_path__ + "img/ico-polygon.7945dafb.svg";